module.exports = __webpack_public_path__ + "img/exp_back.eaed9092.png";